import React from 'react'
import { IconAlertTriangle, IconCheck, IconClock, IconLoader2, IconX } from '@tabler/icons-react'

export const statusMap = {
  pending: {
    status: { informative: true },
    icon: <IconClock />,
    label: 'Pending',
    tooltip: 'Waiting in queue',
  },
  postcall_started: {
    status: { brand: true },
    icon: <IconLoader2 />,
    label: 'Processing',
    tooltip: 'Currently processing',
  },
  postcall_complete: {
    status: { success: true },
    icon: <IconCheck />,
    label: 'Complete',
    tooltip: 'Processing finished successfully',
  },
  error: {
    status: { critical: true },
    icon: <IconX />,
    label: 'Error',
    tooltip: 'Processing failed',
  },
  invalid_duration: {
    status: { warning: true },
    icon: <IconAlertTriangle />,
    label: 'Invalid Duration',
    tooltip: 'Duration outside allowed range',
  },
}

export const errorMap = {
  'unsupported audio file format': 'Unsupported audio format',
  'audio file s3 key not found': 'Audio file not found',
  'Invalid audio data': 'Unable to read audio file',
  'Invalid number of channels': 'Unsupported audio channels',
  'User not found and cannot auto-provision without first_name and last_name':
    'Missing user info for auto-provisioning',
  'User not found and cannot auto-provision without playbook_name':
    'Missing playbook for auto-provisioning',
  'Invalid playbook name': 'Playbook not found',
  'Unexpected error': 'Something went wrong',
  'Audio upload was interrupted': 'Upload was interrupted',
}

// Shown when the browser can't read a selected file during upload
export const FILE_READ_ERROR_MSG =
  "We couldn't read this file. Make sure it hasn't been moved or deleted, then select it again and retry."

// Rewrites noisy backend upload errors (e.g. "cannot proceed with diarization")
// into plain-English copy. Unknown strings pass through so engineers still see
// the real detail; blank payloads get a generic fallback.
export const friendlyUploadError = (raw) => {
  if (!raw) {
    return 'Something went wrong. Try again.'
  }
  if (/diariz/i.test(raw)) {
    return "We couldn't separate the voices in this recording. Make sure both the agent and customer can be heard clearly."
  }
  if (/silence/i.test(raw)) {
    return 'This recording appears to be silent. Check the file and try again.'
  }
  if (/postcall/i.test(raw)) {
    return "We couldn't process this file. Try uploading it again."
  }
  return raw
}
